import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import Cfg from '../configuration.vue'

import AreaRepository from '@/shared/http/repositories/configuration/area'
import DocumentTypeRepository from '@/shared/http/repositories/configuration/documenttype'
import DocumentTypeModel from '@/shared/models/configuration/documenttypemodel'
import DocumentTypeForms from './documenttype-form'

export default {
  name: 'DocumentType',
  mixins: [ActionsForm],
  data () {
    return {
      data: DocumentTypeModel,
      form: DocumentTypeForms
    }
  },
  components: {
    Cfg
  },
  mounted () {
    this.onLoadAllArea()
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
    }
  },
  methods: {
    onLoad () {
      loading.push()
      DocumentTypeRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onCreate () {
      loading.push()
      DocumentTypeRepository.Create(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      DocumentTypeRepository.Update(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDelete (obj) {
      loading.push()
      DocumentTypeRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllArea () {
      loading.push()
      AreaRepository.GetAll()
        .then((response) => {
          this.form.areaID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/documenttype/documenttype.js